<template>
  <div>
    <div class="d-flex align-center pb-1">
      <span class="font-14 font-weight-medium">Colunas selecionadas</span>
    </div>

    <div id="colunas-selecionadas" @dragover="dragover">
      <div
        v-for="(coluna, index) in COLUNAS_SELECIONDAS"
        :key="index"
        class="coluna d-flex align-center justify-space-between"
        :class="{'coluna-dragover': coluna_em_dragover.value === coluna.value}"
        :draggable="true"
        @dragstart="ev => dragstart(ev, coluna)"
        @dragover="ev => dragover(ev, index)"
      >
        {{ coluna.text }}
        <v-icon :size="17" @click="removerColunaDaSelecao(coluna)">mdi-close</v-icon>
      </div>
    </div>
  </div>
</template>

<script>
import InputPesquisa from "./InputPesquisa.vue";

export default {
  name: "BlocoItensDragDrop",
  components: {InputPesquisa},
  model: {
    prop: "modelValue",
    event: "update:modelValue",
  },
  props: {
    modelValue: Array,
  },
  data: () => ({
    coluna_em_dragover: {},
    timer_limpar_coluna_em_dragover: null,
  }),
  computed: {
    COLUNAS_SELECIONDAS: {
      get() {
        return this.modelValue;
      },
      set(valor) {
        this.$emit("update:modelValue", valor);
      }
    }
  },
  methods: {
    colunaEstaSelecionada(coluna) {
      return this.COLUNAS_SELECIONDAS.some(col => col.value === coluna.value);
    },
    removerColunaDaSelecao(coluna) {
      this.COLUNAS_SELECIONDAS = this.COLUNAS_SELECIONDAS.filter(col => col.value !== coluna.value);
    },
    dragstart(ev, coluna) {
      ev.dataTransfer.setData("text", JSON.stringify(coluna));
    },
    dragover(ev, index_add_coluna = null) {
      this.coluna_em_dragover = JSON.parse(ev.dataTransfer.getData("text"));

      if (!this.colunaEstaSelecionada(this.coluna_em_dragover)) {
        this.COLUNAS_SELECIONDAS.push(this.coluna_em_dragover);
      }

      if (index_add_coluna !== null) {
        this.reposicionarColunaDentroDoArray(this.coluna_em_dragover, index_add_coluna);
      }

      clearTimeout(this.timer_limpar_coluna_em_dragover);
      this.timer_limpar_coluna_em_dragover = setTimeout(() => this.coluna_em_dragover = {}, 500);
    },
    reposicionarColunaDentroDoArray(coluna_drag, index_of_destino) {
      const colunas = this.COLUNAS_SELECIONDAS.filter(col => col.value !== coluna_drag.value);
      colunas.splice(index_of_destino, 0, coluna_drag);
      this.COLUNAS_SELECIONDAS = colunas;
    }
  }
}
</script>

<style scoped>
#colunas-selecionadas {
  height: 40vh;
  overflow-y: auto;
  background: #f5f5f5;
  padding: 3px 3px;
  border: 1px solid #e5e5e5;
  user-select: none;
}
#colunas-selecionadas .coluna {
  color: #1a1a1a;
  font-size: 12px;
  border: 1px solid #e5e5e5;
  margin: 0 0 3px 0;
  padding: 0 5px;
  background: #fdfdfd;
  user-select: none;
}
#colunas-selecionadas .coluna-dragover {
  border: 0.13rem dashed #5983c3;
}
</style>
